import { render, staticRenderFns } from "./AFecha.vue?vue&type=template&id=48c4ed1c"
import script from "./AFecha.vue?vue&type=script&lang=js"
export * from "./AFecha.vue?vue&type=script&lang=js"
import style0 from "./AFecha.vue?vue&type=style&index=0&id=48c4ed1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports